module.exports = __webpack_public_path__ + "static/media/noproduct.b702792a.png";